import React from 'react';
import Config from '../../../../config.web';
import importSectionStyles from '../../ImportSection.styles';

const NetSuiteInstruction = () => {
    return (
        <div style={importSectionStyles.instructionCard}>
            <strong style={importSectionStyles.title}>Sage Intacct Instructions</strong>
            <ul style={importSectionStyles.instructions}>
                <li>1. Login to NetSuite and select your company. Then go to Customization {'>'} SuiteBuilder {'>'} Search & Install Bundles.</li>
                <li>2. Under Keywords, type {Config.APP_BASE_URL} Then, click Search.</li>
                <li>3. Click {Config.APP_BASE_URL} — Vendor Payment Reports.</li>
                <li>4. Click Install.</li>
                <li>5. On the Components page, click Install Bundle.</li>
                <li>6. In the popup box, click OK.</li>
                <li>7. Wait for the bundle to be installed. The status of the bundle will change from Pending to a check mark. Click Refresh to see the current status.</li>
                <li>8. Go to Reports {'>'} Saved Searches {'>'} {Config.APP_BASE_URL} - Vendor Payment Reports for NEC or {Config.APP_BASE_URL} - Vendor Payment Reports for MISC. Then click Edit.</li>
                <li>9. Select the Criteria tab to make changes.</li>
                <li>10. Next, select Results and make sure the vendor fields are correct.</li>
                <li>11. If you made any changes to the report, enter a new report name in the Search Title box and click Save As. Otherwise, the changes and search criteria will not save.</li>
                <li>12. Click Submit and review the results of the report to make sure it is accurate.</li>
                <li>13. Then, it’s time to export and download. You can Export – CSV icon or click on the green Export – Microsoft Excel icon.</li>
                <li>14. Once you download the report, you can copy and paste it into our {Config.APP_BASE_URL} template, which can be found under Import {'>'} Excel Spreadsheet.</li>
                <li>15. Next, go to NetSuite Import in {Config.APP_BASE_URL} and import selected files.</li>

            </ul>
        </div>
    );
};

export default NetSuiteInstruction;
